@if (defaults.isadminuser) {
  <table-material
    id-table="controller-type-id"
    [header]="header"
    [data]="defaults.controllertypes"
    [getValue]="getData"
    (onNewElement)="onNewControllerType()"
    [selectable]="false">
  </table-material>
}
